import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { PromotionKitsReportsData } from './promotion-kit-report-interface';

class ClientReportChecklistService {
  getListAllPromotionKitReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<PromotionKitsReportsData[] | null>> {
    return api.get('/order/report/promotion-kit', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/order/report/promotion-kit?count=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getClients({
    skip = 0,
    limit = 30,
    userExternalCode,
    queryString
  }: {
    skip?: number;
    limit?: number;
    userExternalCode: string;
    queryString: string;
  }): Promise<AxiosResponse<any[] | null>> {
    return api.get<any[]>('/client', {
      params: {
        skip,
        limit,
        fieldsToShow: 'externalCode,name',
        userExternalCode,
        queryString
      }
    });
  }

  getXslx({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/order/report/promotion-kit', {
      params: {
        xlsx: true,
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }
}

export default new ClientReportChecklistService();
